import {
  NavigateOptions,
  URLSearchParamsInit,
} from 'modules/Monitoring/router/useSearchParams'

export type UpdateTask = (params: URLSearchParams) => void

export type SetSearchParamsFn = (
  next: URLSearchParamsInit | ((prev: URLSearchParams) => URLSearchParamsInit),
  navigateOptions?: NavigateOptions,
) => void

export class SearchParamsQueue {
  private updateQueue: UpdateTask[] = []

  private pendingReplace = false

  private isUpdateScheduled = false

  private latestSetSearchParams: SetSearchParamsFn | null = null

  public schedule(
    task: UpdateTask,
    setSearchParams: SetSearchParamsFn,
    replace: boolean,
  ) {
    this.updateQueue.push(task)
    this.latestSetSearchParams = setSearchParams

    if (replace) {
      this.pendingReplace = true
    }

    if (!this.isUpdateScheduled) {
      this.isUpdateScheduled = true

      queueMicrotask(this.commitUpdates.bind(this))
    }
  }

  private commitUpdates() {
    if (!this.latestSetSearchParams || this.updateQueue.length === 0) {
      this.isUpdateScheduled = false
      return
    }

    const currentQueue = [...this.updateQueue]
    const currentReplace = this.pendingReplace

    this.updateQueue = []
    this.pendingReplace = false
    this.isUpdateScheduled = false

    this.latestSetSearchParams(
      prevParams => {
        const nextParams = new URLSearchParams(prevParams)
        currentQueue.forEach(task => task(nextParams))
        return nextParams
      },
      { replace: currentReplace },
    )
  }

  public clear() {
    this.updateQueue = []
    this.pendingReplace = false
    this.isUpdateScheduled = false
    this.latestSetSearchParams = null
  }
}
